export default __webpack_public_path__ + "static/premio-ec-59647e5bb7ab66e4ab8e3dc524f0d670.gif";